// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
::ng-deep .my-table {
  width: 100%;
}
::ng-deep .my-table thead tr {
  background: #fff;
}
::ng-deep .my-table .mdc-data-table__content .mat-mdc-row {
  border: 1px solid #e7e7e7;
}
::ng-deep .my-table .mdc-data-table__content .mat-mdc-row:nth-child(odd) {
  background-color: #f6f6f6;
}

.letter {
  display: inline-block;
}
.letter::before {
  content: " ";
}
.letter::after {
  content: ",";
}
.letter:last-child::after {
  content: "";
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.toolbar {
  background-color: #41444d;
  height: 55px;
  color: white;
  font-size: 25px;
}

.button-bar {
  background-color: white;
  height: 55px;
  font-size: 25px;
  font-weight: 100;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  gap: 10px;
}
.button-bar button {
  min-width: 200px;
}
.button-bar button:nth-child(3) {
  margin-left: auto;
}

.main {
  flex: 1;
  padding: 0 20px 20px;
  display: flex;
  overflow: hidden;
}
.main-table {
  width: 100%;
  overflow: auto;
  table-layout: fixed;
}
.main .my-table .id, .main .my-table .edit {
  width: 5%;
}
.main .my-table .name, .main .my-table .email {
  width: 10%;
}
.main .my-table .letter, .main .my-table .desc {
  width: 30%;
}
.main .my-table .edit {
  cursor: pointer;
}
.main .my-table mat-column-objectName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.main .my-table .comTitle {
  border: 0.1px solid;
  border-radius: 8px;
  padding: 5px;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 3px;
  margin: 3px;
}
.main .my-table .comTitle img {
  cursor: pointer;
}

mat-form-field {
  margin: 20px 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/users-dpm/users-dpm-list/users-dpm-list.component.scss","webpack://./src/app/shared/table.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;EACE,WAAA;ADCJ;ACEM;EACE,gBAAA;ADAR;ACKM;EACE,yBAAA;ADHR;ACKQ;EACE,yBAAA;ADHV;;ACUA;EACE,qBAAA;ADPF;ACSE;EACE,YAAA;ADPJ;ACUE;EACE,YAAA;ADRJ;ACYI;EACE,WAAA;ADVN;;AAvBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA0BF;;AAvBA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AA0BF;;AAvBA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,SAAA;AA0BF;AAxBE;EACE,gBAAA;AA0BJ;AAzBI;EACE,iBAAA;AA2BN;;AAtBA;EACE,OAAA;EACA,oBAAA;EACA,aAAA;EACA,gBAAA;AAyBF;AAvBE;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AAyBJ;AArBI;EACE,SAAA;AAuBN;AApBI;EACE,UAAA;AAsBN;AAnBI;EACE,UAAA;AAqBN;AAlBI;EACE,eAAA;AAoBN;AAjBI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAmBN;AAhBI;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAkBN;AATM;EACE,eAAA;AAWR;;AALA;EACE,mBAAA;AAQF","sourcesContent":["@import '../../../shared/table.scss';\r\n\r\n:host {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.toolbar {\r\n  background-color: #41444d;\r\n  height: 55px;\r\n  color: white;\r\n  font-size: 25px;\r\n}\r\n\r\n.button-bar {\r\n  background-color: white;\r\n  height: 55px;\r\n  font-size: 25px;\r\n  font-weight: 100;\r\n  border-bottom: 1px solid #e7e7e7;\r\n  display: flex;\r\n  gap: 10px;\r\n\r\n  button {\r\n    min-width: 200px;\r\n    &:nth-child(3) {\r\n      margin-left: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.main {\r\n  flex: 1;\r\n  padding: 0 20px 20px;\r\n  display: flex;\r\n  overflow: hidden;\r\n\r\n  &-table {\r\n    width: 100%;\r\n    overflow: auto;\r\n    table-layout: fixed;\r\n  }\r\n\r\n  .my-table {\r\n    .id, .edit {\r\n      width: 5%;\r\n    }\r\n\r\n    .name, .email {\r\n      width: 10%;\r\n    }\r\n\r\n    .letter, .desc {\r\n      width: 30%;\r\n    }\r\n\r\n    .edit {\r\n      cursor: pointer;\r\n    }\r\n\r\n    mat-column-objectName {\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n    }\r\n\r\n    .comTitle {\r\n      border: 0.1px solid;\r\n      border-radius: 8px;\r\n      padding: 5px;\r\n      width: fit-content;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 3px;\r\n      margin: 3px;\r\n\r\n      // .deleteComplex{\r\n      //   width: fit-content;\r\n      //   height: fit-content;\r\n      //   padding: 2px;\r\n      //   cursor: pointer;\r\n      // }\r\n\r\n      img {\r\n        cursor: pointer;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nmat-form-field {\r\n  margin: 20px 20px 0;\r\n}","::ng-deep {\r\n  .my-table {\r\n    width: 100%;\r\n\r\n    thead {\r\n      tr {\r\n        background: #fff;\r\n      }\r\n    }\r\n\r\n    .mdc-data-table__content {\r\n      .mat-mdc-row {\r\n        border: 1px solid #e7e7e7;\r\n\r\n        &:nth-child(odd) {\r\n          background-color: #f6f6f6;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.letter {\r\n  display: inline-block;\r\n\r\n  &::before {\r\n    content: '\\00a0'\r\n  }\r\n\r\n  &::after {\r\n    content: ','\r\n  }\r\n\r\n  &:last-child {\r\n    &::after {\r\n      content: ''\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
